import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Heart } from "lucide-react";
import { LINKS, IMAGES } from "@/data/site";

export const DonatePopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const seen = sessionStorage.getItem("hft_donate_seen");
    if (seen) return;
    const t = setTimeout(() => {
      setOpen(true);
      sessionStorage.setItem("hft_donate_seen", "1");
    }, 3500);
    return () => clearTimeout(t);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="max-w-md overflow-hidden rounded-3xl border-[#E5DCC5] bg-[#FDFBF7] p-0"
        data-testid="donate-popup"
      >
        <div className="relative h-40 w-full overflow-hidden">
          <img
            src={IMAGES.cat}
            alt="Rescue animal"
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#FDFBF7] to-transparent" />
        </div>
        <div className="px-8 pb-8 -mt-6 relative">
          <DialogHeader>
            <DialogTitle className="font-display text-3xl font-bold text-[#2B2D42] text-left">
              Give a tail a second chance
            </DialogTitle>
            <DialogDescription className="text-[#4A4E69] text-left text-base leading-relaxed pt-2">
              Would you like to support local shelter animals today? Every dollar
              helps us provide food, care, and comfort to pets in need.
            </DialogDescription>
          </DialogHeader>
          <div className="mt-6 flex flex-col gap-3">
            <a
              href={LINKS.gofundme}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              data-testid="popup-donate-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#E07A5F] px-6 py-3.5 font-semibold text-white transition-all hover:bg-[#D06A4F] active:scale-95"
            >
              <Heart className="h-4 w-4 fill-white" /> Donate now
            </a>
            <button
              onClick={() => setOpen(false)}
              data-testid="popup-dismiss-btn"
              className="text-sm font-medium text-[#4A4E69] hover:text-[#2B2D42] transition-colors"
            >
              Maybe later
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
